import React from 'react';
import { SlideLayout } from '../ui/SlideLayout';
import { BarChart3Icon, SettingsIcon, FileEditIcon, GlobeIcon, CheckIcon } from 'lucide-react';
function PlanCard({
  icon: Icon,
  title,
  items
}: {
  icon: any;
  title: string;
  items: string[];
}) {
  return <div data-id="element-269">
      <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4" data-id="element-270">
        <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-slate-100 flex items-center justify-center" data-id="element-271">
          <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-gold-600" data-id="element-272" />
        </div>
        <h3 className="text-sm sm:text-lg font-bold text-slate-900" data-id="element-273">{title}</h3>
      </div>
      <ul className="space-y-1.5 sm:space-y-2.5" data-id="element-274">
        {items.map((item, i) => <li key={i} className="flex items-start gap-2 sm:gap-2.5" data-id="element-275">
            <CheckIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-gold-500 shrink-0 mt-0.5" data-id="element-276" />
            <span className="text-xs sm:text-sm text-slate-600 leading-tight" data-id="element-277">
              {item}
            </span>
          </li>)}
      </ul>
    </div>;
}
export function MonthlySEOPlan() {
  return <SlideLayout className="pt-12 sm:pt-16" data-id="element-278">
      <div className="mb-4 sm:mb-8 text-center" data-id="element-279">
        <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-2 sm:mb-4" data-id="element-280">
          Monthly SEO Plan
        </h2>
      </div>

      <div className="relative overflow-hidden rounded-xl sm:rounded-2xl bg-gradient-to-r from-slate-50 to-white border border-gold-500/40 p-4 sm:p-8 mb-4 sm:mb-8 shadow-md text-center" data-id="element-281">
        <div className="absolute top-0 right-0 w-40 sm:w-64 h-40 sm:h-64 bg-gold-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4 pointer-events-none" data-id="element-282" />

        <div className="inline-block px-3 sm:px-4 py-1 sm:py-1.5 rounded-full bg-gold-500/15 text-gold-600 text-xs sm:text-sm font-bold tracking-wider uppercase mb-2 sm:mb-4" data-id="element-283">
          Essential SEO Plan
        </div>
        <div className="flex items-end justify-center gap-1 sm:gap-2 mb-1 sm:mb-2" data-id="element-284">
          <span className="text-3xl sm:text-5xl font-extrabold text-slate-900" data-id="element-285">
            $1,250
          </span>
          <span className="text-base sm:text-xl text-slate-500 mb-0.5 sm:mb-1" data-id="element-286">
            /month
          </span>
        </div>
        <p className="text-gold-600 font-medium text-sm sm:text-base mb-2 sm:mb-4" data-id="element-287">
          6-Month Engagement
        </p>
        <p className="text-xs sm:text-base text-slate-600 max-w-xl mx-auto" data-id="element-288">
          Designed to improve rankings, traffic, and qualified mortgage leads.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4" data-id="element-289">
        <PlanCard icon={BarChart3Icon} title="Reporting & Strategy" items={['20 monthly focus keywords', 'Keyword research & competitor research', 'Keyword-to-page mapping', 'Google Analytics & Search Console setup', 'Keyword tracking & ongoing updates', 'Monthly summary report']} data-id="element-290" />
        <PlanCard icon={SettingsIcon} title="Technical SEO" items={['Page speed reporting & 1hr repair', 'Schema markup editing', 'Robots.txt & XML sitemap', 'SSL certificate validation', 'W3C validation', 'Hosting & DNS error monitoring']} data-id="element-291" />
        <PlanCard icon={FileEditIcon} title="On-Page SEO" items={['Content writing: 6 pages', 'Duplicate content analysis & 1hr repair', 'Canonical analysis & 1hr repair', 'Meta title & description writing', '10 pages optimized', 'Broken link fixes']} data-id="element-292" />
        <PlanCard icon={GlobeIcon} title="Off-Page SEO" items={['2 blog posts per month', '6 business listings', 'Link building budget: $150', 'GMB optimization', '4 GMB posts per month']} data-id="element-293" />
      </div>
    </SlideLayout>;
}